// extracted by mini-css-extract-plugin
export default {"wrapper":"FooterMobile_wrapper__iFdRz","item":"FooterMobile_item__Q0fvM","active":"FooterMobile_active__WuAz2"};